<template>
  <div style="width: 1180px; margin: 0 auto">
    <base-bread-crumb
      class="bread-crumb"
      :currBreadCrumb="currBreadCrumb"
      :isShowPortal="true"
    ></base-bread-crumb>
    <div class="ccui-app-container">
      <div class="ccui-multifunctional-table-wrapper dialog-body">
        <!-- <div class="nocaptcha-wp" v-if="isCode">
          <NoCaptcha
            ref="NoCaptcha"
            class="nocaptcha"
            @successAWSC="successAWSC"
          />
        </div> -->
        <div class="tis">管控名单或黑名单申诉</div>
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="160px"
          class="ccui-form"
        >
          <el-form-item label="申请类型：" prop="appealType">
            <el-select
              v-model="form.appealType"
              @change="changeType(1)"
              clearable
              placeholder="请选择申请类型"
              class="ccui-form-shortInput"
            >
              <el-option key="1" label="申诉" value="1"></el-option>
              <el-option key="2" label="信用修复" value="2"></el-option>
              <!-- <el-option key="3" label="重新认定" value="3"></el-option> -->
            </el-select>
          </el-form-item>

          <el-form-item label="申请单位名称：" prop="subconName">
            <el-input
              v-model.trim="form.subconName"
              class="ccui-form-shortInput"
              placeholder="请输入申请单位名称"
              clearable
              maxlength="50"
            />
          </el-form-item>

          <el-form-item
            v-if="form.appealType == 2 || form.appealType == 3"
            label="修复类型："
            prop="repairType"
          >
            <el-select
              v-model="form.repairType"
              clearable
              @change="changeType(2)"
              placeholder="请选择修复类型"
              class="ccui-form-shortInput"
            >
              <el-option key="1" label="管控名单" value="1"></el-option>
              <el-option
                v-if="form.appealType == 2"
                key="2"
                label="黑名单"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="form.appealType == 3"
            label="管控范围："
            prop="controlRangeCode"
          >
            <el-select
              v-model="form.controlRangeCode"
              clearable
              @focus="getFcousNew"
              @change="changeType(3)"
              placeholder="请选择限制范围"
              class="ccui-form-shortInput"
            >
              <el-option
                v-for="(item, index) in controlList"
                :key="index"
                :label="item.controlRangeName"
                :value="item.controlRangeCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="form.appealType == 2 && form.repairType == '2'"
            label="限制范围："
            prop="controlRangeCode"
          >
            <el-select
              v-model="form.controlRangeCode"
              clearable
              @focus="getFcous"
              @change="changeType(3)"
              placeholder="请选择限制范围"
              class="ccui-form-shortInput"
            >
              <el-option
                v-for="(item, index) in controlList"
                :key="index"
                :label="item.controlRangeName"
                :value="item.controlRangeCode"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="!(form.repairType == 2) && form.appealType != 3"
            label="单据编号："
            prop="businessCode"
          >
            <el-input
              v-model="form.businessCode"
              class="ccui-form-shortInput"
              placeholder="请输入单据编号"
              clearable
              maxlength="50"
            />
          </el-form-item>
          <el-form-item label="申请理由：" prop="appealRemark">
            <el-input
              v-model="form.appealRemark"
              class="ccui-form-shortInput"
              placeholder="请输入申请理由"
              clearable
              maxlength="50"
            />
          </el-form-item>
          <!-- <el-form-item label="邮箱：" prop="reqemail">
            <el-input
              v-model="form.reqemail"
              class="ccui-form-shortInput"
              placeholder="请输入邮箱"
              clearable
              maxlength="50"
            />
          </el-form-item> -->

          <el-form-item label="手机号码：" prop="phoneNumbers">
            <div
              style="
                display: flex;
                width: 300px;
                /* align-items: self-end; */
                justify-content: space-between;
              "
            >
              <el-input
                style="margin-right: 5px"
                v-model="form.phoneNumbers"
                placeholder="请输入手机号码"
                clearable
                maxlength="11"
              />
              <el-button @click="sendCode" :disabled="isSend"
                ><span v-if="isSend">{{ countDown }}秒后</span
                >发送验证码</el-button
              >
              <div class="islider" v-if="isCode">
                <Slider
                  @close="
                    isCode = false;
                    isSend = false;
                  "
                  :log="true"
                  @getImg="getImg"
                  @validImg="validImg"
                ></Slider>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="验证码：" prop="verificationCode">
            <el-input
              v-model="form.verificationCode"
              class="ccui-form-shortInput"
              placeholder="请输入验证码"
              clearable
              maxlength="50"
            />
          </el-form-item>
          <!-- <el-form-item label="附件模板：">
            <a
              class="donload-font"
              download="交建云商密码找回模板"
              href="https://cccc-prod.obs.cn-north-4.myhuaweicloud.com/cccc_temp/temp25582ca272664fd99c05de84382dbe5b.doc"
              >点击此处下载</a
            >附件模板（按照模板填写之后上传）
          </el-form-item> -->

          <el-form-item label="附件上传：" prop="fileurl">
            <el-upload
              :show-file-list="false"
              :action="url"
              style="display: inline-block"
              :before-upload="beforeAvatarUpload"
              :on-success="onSuccess"
              :on-progress="onProgress"
              :on-error="onError"
            >
              <!-- :data="fromData" -->
              <div slot="tip" class="el-upload__tip">
                只能上传doc/docx/pdf文件，且不超过50M
              </div>
              <el-button plain type="single-number"> 点击上传 </el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="">
            <div
              v-if="fileList && fileList.length > 0"
              class="file-list"
              :title="fileList[0].fileName"
            >
              {{ fileList[0].fileName }}
              <div class="paa">
                <el-button size="mini" type="text" @click="deleteFile"
                  >删除</el-button
                >
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div style="padding-left: 96px" class="dialog-footer">
          <el-button style="width: 140px" type="primary" @click="submit"
            >提 交</el-button
          >
          <el-button style="width: 140px" @click="handleClose">重 置</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  dealSubSupBlackAppealInfo,
  send,
  getImageVerifyCode,
  sendAppealInfoVerificationCode,
  querySubSupBlackAppealInfoBySubconNameForSup,
  querySubconControlAppealUnitList
} from "@/app/shop/api/shopping";
// import NoCaptcha from "./NoCaptcha.vue";
import BaseBreadCrumb from "@/app/noticesList/components/baseBreadCrumb.vue";
import { addUrlPerFix } from "@/basa/utils";
import Slider from "./slider";

export default {
  name: "subFindPassword",
  components: { BaseBreadCrumb, Slider },
  props: {},
  data() {
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      currBreadCrumb: [{ title: "管控名单或黑名单申诉" }],
      controlList: [],
      code: "",
      countDown: 60,
      isSend: false,
      showBtn: true,
      dialogVisible: false,
      isCode: false,
      form: {
        subconName: "",
        controlRangeCode: "",
        subconCode: "",
        unifiedCreditCode: "",
        controlRangeName: "",
        controlRangeExtOid: "",
        controlRangeId: "",
        controlRangeShortName: "",
        accessCode: "",
        accessExtOid: "",
        accessId: "",
        accessName: "",
        supCode: "",
        accessShortName: "",
        orgId: "",
        repairType: "",
        phoneNumbers: "",
        businessCode: "",
        appealRemark: "",
        appealType: "",
        fileurl: "",
        uploadId: "",
        fileName: "",
        verificationCode: ""
      },
      fromData: { openId: "", userName: "" },
      rules: {
        appealType: [
          {
            required: true,
            message: "请选择申请类型",
            trigger: ["blur", "change"]
          }
        ],
        subconName: [
          { required: true, message: "请输入申请单位名称", trigger: "blur" }
        ],
        businessCode: [
          { required: true, message: "请输入单据编号", trigger: "blur" }
        ],
        appealRemark: [
          { required: true, message: "请输入申请理由", trigger: "blur" }
        ],
        repairType: [
          { required: true, message: "请选择修复类型", trigger: "blur" }
        ],
        controlRangeCode: [
          { required: true, message: "请选择限制范围", trigger: "blur" }
        ],
        fileurl: [{ required: true, message: "请上传附件", trigger: "change" }],
        reqemail: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }
        ],
        phoneNumbers: [
          {
            required: true,
            validator: checkPhone,
            trigger: ["blur", "change"]
          }
        ]
      },
      fileList: [
        {
          fileName: ""
        }
      ],
      url: `${addUrlPerFix(
        process.env.VUE_APP_BASEP_URL
      )}/apis/basap/users/signup/uploadLogo`
    };
  },
  created() {},
  methods: {
    getConListNew() {
      querySubconControlAppealUnitList({
        subconName: this.form.subconName,
        sourceOpper: "0",
        appealType: "3"
      }).then(res => {
        if (res.data.code === "0") {
          this.controlList = res.data.data.rows;
        }
      });
    },
    getConList() {
      querySubSupBlackAppealInfoBySubconNameForSup({
        subconName: this.form.subconName,
        sourceOpper: "0"
      }).then(res => {
        if (res.data.code === "0") {
          this.controlList = res.data.data.rows;
        }
      });
    },
    sendCode() {
      this.isSend = true;
      if (!this.form.phoneNumbers) {
        this.$message.warning("手机号不能为空！");
        this.isSend = false;
        return;
      }
      this.isCode = true;
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(blcokLeft, id, callback) {
      console.log(123444);
      // blcokLeft,// 手动定位返回的值
      //   id// 后台返回的id，再传回去
      this.handleLogin(blcokLeft, id, callback); // 登陆请求方法
    },
    handleLogin(blcokLeft, id, callback) {
      if (this.form.phoneNumbers) {
        this.isSend = true;
        if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.phoneNumbers)) {
          sendAppealInfoVerificationCode({
            phoneNumbers: this.form.phoneNumbers,
            checkCodeLimitTime: blcokLeft,
            businessCode: id
          })
            .then(res => {
              if (res.data.code === "0") {
                callback({ data: true });
                this.isCode = false;
                this.$message({
                  type: "success",
                  message: res.data.message
                });
                let timer = setInterval(() => {
                  if (this.countDown > 0) {
                    this.countDown--;
                    this.isSend = true;
                  } else {
                    clearInterval(timer);
                    this.isSend = false; // 启用按钮
                    this.countDown = 60; // 重置倒计时时间
                  }
                }, 1000);
                return false;
              } else {
                this.isSend = false;
                callback({ data: false, message: res.data.message });
                this.isCode = true;
              }
            })
            .catch(errMessage => {
              this.isSend = false;
            });
        } else {
          this.$message({
            showClose: true,
            type: "error",
            message: "请输入正确的手机号",
            ccuiCustom: true
          });
        }
      }
    },
    changeType(type) {
      if (type === 1) {
        // 切换类型需要重置数据
        // if (this.form.appealType) {
        // 不是黑名单需要吧管控范围数据清空
        this.controlList = [];
        this.form.repairType = "";
        this.form.controlRangeCode = "";
        this.form.unifiedCreditCode = "";
        this.form.subconCode = "";
        this.form.controlRangeName = "";
        this.form.controlRangeExtOid = "";
        this.form.controlRangeId = "";
        this.form.controlRangeShortName = "";
        this.form.accessShortName = "";
        this.form.accessName = "";
        this.form.supCode = "";
        this.form.accessId = "";
        this.form.accessExtOid = "";
        this.form.accessCode = "";
        this.form.orgId = "";
        // }
      } else if (type === 2) {
        // 切换修复类型需要重置数据
        this.form.controlRangeCode = "";
        this.form.unifiedCreditCode = "";
        this.form.subconCode = "";
        this.form.controlRangeName = "";
        this.form.controlRangeExtOid = "";
        this.form.controlRangeId = "";
        this.form.controlRangeShortName = "";
        this.form.accessShortName = "";
        this.form.accessName = "";
        this.form.supCode = "";
        this.form.accessId = "";
        this.form.accessExtOid = "";
        this.form.accessCode = "";
        this.form.orgId = "";
        if (this.form.repairType == 2) {
          // 选黑名单类型请求接口
          this.form.businessCode = "";
        }
      } else if (type === 3) {
        // 切换限制范围
        if (this.form.controlRangeCode) {
          this.controlList.forEach(item => {
            if (item.controlRangeCode === this.form.controlRangeCode) {
              this.form.controlRangeName = item.controlRangeName;
              this.form.controlRangeExtOid = item.controlRangeExtOid;
              this.form.controlRangeId = item.controlRangeId;
              this.form.controlRangeShortName = item.controlRangeShortName;
              this.form.orgId = item.orgId;
              this.form.subconCode = item.subconCode;
              this.form.unifiedCreditCode = item.unifiedCreditCode;
              this.form.accessCode = item.accessCode;
              this.form.accessExtOid = item.accessExtOid;
              this.form.accessId = item.accessId;
              this.form.accessName = item.accessName;
              this.form.supCode = item.supCode;
              this.form.accessShortName = item.accessShortName;
              if (this.form.appealType == 3) {
                this.form.businessCode = item.businessCode;
                this.form.orgId = "";
              }
            }
          });
        }
      }
    },
    getFcous() {
      if (!this.form.subconName) {
        return this.$message({
          message: "请先填写申请单位名称",
          type: "error",
          duration: 3000,
          ccuiCustom: true,
          showClose: true,
          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        this.getConList();
      }
    },
    getFcousNew() {
      if (!this.form.subconName) {
        return this.$message({
          message: "请先填写申请单位名称",
          type: "error",
          duration: 3000,
          ccuiCustom: true,
          showClose: true,
          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        this.getConListNew();
      }
    },
    // 获取滑动验证码的图片
    getImg(callback) {
      let that = this;
      getImageVerifyCode({}).then(
        res => {
          callback(res.data);
        },
        error => {
          that.isSend = false;
          that.isCode = false;
          callback(error);
        }
      );
    },
    successAWSC(obj) {
      this.isCode = false;
      this.showBtn = obj.disabledBtn;
      this.code = obj.code;

      send({
        phoneNumbers: this.form.phoneNumbers,
        sessionId: obj.code,
        agentId: 100003
      }).then(res => {
        if (res.data.code == "0" && res.data.message == "成功") {
          let timer = setInterval(() => {
            if (this.countDown > 0) {
              this.countDown--;
              this.isSend = true;
            } else {
              clearInterval(timer);
              this.isSend = false; // 启用按钮
              this.countDown = 60; // 重置倒计时时间
            }
          }, 1000);
        }
      });
    },
    handleClose(done) {
      this.$refs.form.resetFields();
      this.fileList = [{ fileName: "" }];
      this.showBtn = true;
      this.isCode = false;
    },
    beforeAvatarUpload(file) {
      if (this.fileList.length > 1) {
        this.$message.warning("单次只能上传一个附件");
        return;
      }
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf("."));
      let fileType = [
        ".doc",
        ".docx",
        ".DOC",
        ".DOCX",
        ".pdf",
        ".PDF"
      ].includes(testmsg);
      if (!isLt50) {
        // "文件大小不超过50M!"
        this.$message({
          showClose: true,
          message: "文件大小不超过50M!",
          type: "error",
          duration: 0
        });
      }
      if (file.size === 0) {
        // "文件大小不可为0B!"
        this.$message({
          showClose: true,
          message: "文件大小不可为0B!",
          type: "error",
          duration: 0
        });
      }
      if (!fileType) {
        // "上传文件格式错误！"
        this.$message({
          showClose: true,
          message: "上传文件格式错误！",
          type: "error",
          duration: 0
        });
      }
      return isLt50 && fileType && file.size > 0;
    },
    onProgress(res) {
      this.uploadLoading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    onSuccess(res) {
      let fileData = res.data[0];
      this.$set(this.fileList, 0, {
        fileName: fileData.fileName
      });
      this.form.fileurl = fileData.downloadUrl;
      this.form.fileName = fileData.fileName;
      this.form.uploadId = fileData.uploadId;
      this.$message.success("上传成功!");
      this.uploadLoading.close();
    },
    deleteFile() {
      this.fileList = [];
      this.form.fileurl = "";
      this.form.fileName = "";
      this.form.uploadId = "";
    },
    onError() {
      // "上传至服务器失败请重新上传"
      this.$message.error("上传至服务器失败请重新上传");
      this.uploadLoading.close();
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.form.fileurl) {
            this.$message.error("请上传附件！");
            return;
          }
          this.$confirm(
            "请确认信息填写是否正确？",
            ""
            // {
            //   iconClass: "el-icon-info",
            // }
          )
            .then(_ => {
              console.log(this.form, "000");
              let obj = JSON.parse(JSON.stringify(this.form));
              obj.repairTypeStr = obj.repairType == 1 ? "管控名单" : "黑名单";
              obj.sourceOpper = "0";
              dealSubSupBlackAppealInfo({
                subSupBlackAppealInfoBO: obj
                // agentId: 100001,
                // sessionId: this.code,
              }).then(res => {
                this.$message({
                  message: "提交成功！",
                  type: "success",
                  duration: 3000,
                  ccuiCustom: true,
                  showClose: true,
                  offset: document.documentElement.clientHeight / 2 - 21
                });
                this.handleClose();
                setTimeout(() => {
                  this.$router.go(-1);
                }, 3000);
              });
            })
            .catch(_ => {
              // this.handleClose();
            });
        } else {
          this.isCode = false;
          this.showBtn = true;
          return false;
        }
      });
    }
  },
  filter: {},
  computed: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
.prr {
  position: relative;
}
//滑动窗样式
.islider {
  width: 400px;
  height: 265px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px rgba(201, 201, 201, 0.5),
    4px 0px 4px 0px rgba(229, 229, 229, 0.5);
  position: absolute;
  top: -278px;
  left: 15px;
}
.islider::before {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid rgba(0, 0, 0, 0.1);
}
.islider::after {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid #ffffff;
  filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, 0.2));
}
.tis {
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px dashed #999999;
  padding: 12px 0;
  margin-bottom: 25px;
}
.bread-crumb {
  padding: 20px 0;
  margin: 0 !important;
}
.ccui-form .ccui-form-shortInput {
  width: 300px;
}
.file-list {
  max-width: 300px;
  padding-right: 50px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
  position: relative;
  .paa {
    position: absolute;
    top: 0;
    left: 320px;
    z-index: 10;
  }
}
.donload-font {
  color: #0089ef;
  text-decoration: underline;
}
.el-dialog__body .el-form /deep/.el-form-item {
  margin-bottom: 27px !important;
}
.dialog-body {
  position: relative;
  .nocaptcha-wp {
    top: 0;
    background: #0000006f;
    width: 100%;
    height: 100%;
    z-index: 10;
    position: absolute;
    .nocaptcha {
      margin: 20% auto;
      width: 300px !important;
    }
  }
}
</style>
